import React from 'react';
import { Navigate } from 'react-router-dom';
import { ReactFCC } from '../interface/react';
import Loading from '../components/Loading/Loading';
import useAuth from '../features/auth/useAuth';

interface ProtectedRouteProps {
	isPublic?: boolean;
}

const ProtectedRoute: ReactFCC<ProtectedRouteProps> = (props) => {
	const { isAuthenticated, isLoadingAuth } = useAuth();
	const { isPublic, children } = props;

	// keeping it on top to avoid showing loading screen for public routes
	if (isPublic) {
		return <div>{children}</div>;
	}

	if (isLoadingAuth) {
		return <Loading />;
	}

	if (!isAuthenticated) {
		return <Navigate to={`/login?redirect=${window.location.pathname}`} />;
	}

	return <div>{children}</div>;
};

export default ProtectedRoute;
